import { render, staticRenderFns } from "./BaseData.vue?vue&type=template&id=1943d3d9"
import script from "./BaseData.vue?vue&type=script&lang=js"
export * from "./BaseData.vue?vue&type=script&lang=js"
import style0 from "./BaseData.vue?vue&type=style&index=0&id=1943d3d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports